import smartSolveApi from './instances/smartsolve';

export const initiateMasterSetupImport = async (file, link, { entityViewName }) => {
  const formData = new FormData();

  formData.append('FileName', file.name);
  formData.append('FileDescription', '');
  formData.append('FileStream', file);
  formData.append('ViewName', entityViewName);
  formData.append('Link', link);

  try {
    const response = await smartSolveApi.post('/InitiateMasterSetupImport', formData);

    return response.data;
  } catch (e) {
    throw new Error(`initiateMasterSetupImport() failed: ${e}`);
  }
};

export const insertSubmissionCodesImport = async (file, link, { entityViewName }) => {
  const formData = new FormData();

  formData.append('FileName', file.name);
  formData.append('FileDescription', '');
  formData.append('FileStream', file);
  formData.append('ViewName', entityViewName);
  formData.append('Link', link);

  try {
    const response = await smartSolveApi.post('/insertSubmissionCodes', formData);

    return response.data;
  } catch (e) {
    throw new Error(`insertSubmissionCodes() failed: ${e}`);
  }
};

export const importMasterSetup = async ({ importKey }) => {
  try {
    const response = await smartSolveApi.post('/ImportMasterSetup', { importKey });

    return response.data;
  } catch (e) {
    throw new Error(`importMasterSetup() failed: ${e}`);
  }
};

export const masterSetupImportStatus = async ({ importKey }) => {
  try {
    const response = await smartSolveApi.post('/importmastersetupstatus', { importKey });

    return response.data;
  } catch (e) {
    throw new Error(`masterSetupImportStatus() failed: ${e}`);
  }
};

export const downloadMasterSetupImportTemplate = async (params) => {
  try {
    const { data, headers } = await smartSolveApi.post(
      '/downloadmastersetupimporttemplate',
      { ...params },
      {
        responseType: 'blob',
      }
    );

    return { data, headers };
  } catch (e) {
    throw new Error(`downloadMasterSetupImportTemplate() failed: ${e}`);
  }
};

export const downloadMasterSetupImportResult = async ({ importKey }) => {
  try {
    const { data, headers } = await smartSolveApi.post(
      '/downloadmastersetupimportresult',
      { importKey },
      {
        responseType: 'blob',
      }
    );

    return { data, headers };
  } catch (e) {
    throw new Error(`downloadMasterSetupImportResult() failed: ${e}`);
  }
};

export const downloadMasterSetupImportedFile = async ({ importKey }) => {
  try {
    const { data, headers } = await smartSolveApi.post(
      '/downloadmastersetupimportedfile',
      { importKey },
      {
        responseType: 'blob',
      }
    );

    return { data, headers };
  } catch (e) {
    throw new Error(`downloadMasterSetupImportedFile() failed: ${e}`);
  }
};

export const masterSetupImportHistory = async ({ importEntityKey }) => {
  try {
    const response = await smartSolveApi.post('/mastersetupimportHistory', {
      ImportEntityKey: importEntityKey,
    });

    return response.data;
  } catch (e) {
    throw new Error(`masterSetupImportHistory() failed: ${e}`);
  }
};
